// extracted by mini-css-extract-plugin
export var actionButtonWrapper = "ldMija52JQeSEMqqsm6y";
export var addressList = "HR3i8xE_Gwow0XuXz_ZG";
export var errorMessage = "Tyvjjubsst3Ajezt7uzQ";
export var helpText = "phahol91TvKDVHNHZVJ9";
export var nameInput = "xajBbc6gyZQiaidgzsgE";
export var pasteButtonWrapper = "sKu8YwRk01dytZfCiTBn";
export var root = "abDSw1wcZphNk1Zs7LJk";
export var warningMessage = "DPnkyjFibcLaAOnhmPye";